export default __webpack_public_path__ + "static/media/price.e036ccd9.svg";